import type { GivingDetail } from 'models';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import { NetworkShare } from 'features/network';
import { useIsGivingOngoing } from '../../hooks';

type P = { card?: boolean; giving: GivingDetail; paymentResult?: boolean };

const SharingButtons = ({ card = false, giving, paymentResult }: P) => {
  const { t } = useTranslation();
  const isGivingOngoing = useIsGivingOngoing({ giving });

  const path = routes.giving.detail(giving.id);
  const subject = paymentResult ? t('Giving email share subject') : undefined;
  const text = paymentResult
    ? t(`Giving email share body`, {
        givingName: giving.name,
        givingPublicUrl: `${window.location.origin}${path}`,
      })
    : undefined;

  return isGivingOngoing ? (
    <NetworkShare
      card={card}
      emailOnlyText={paymentResult}
      entityName={giving.name}
      path={path}
      subject={subject}
      text={text}
    />
  ) : null;
};

export default SharingButtons;
